const snack = require("../../../../../components/snack/snack");
const { getReportDefinition } = require("./reportHub-report-registry");
const customerReports = require("./reportHub-report-customer");
const providerReports = require("./reportHub-report-provider");

let activeDefinition = null;

// --- Helpers de DOM ---
const getEl = (id) => document.getElementById(id);
const getElValue = (id) => getEl(id)?.value || "";
// Agrega la clase 'dn' (display: none) si 'show' es falso, la quita si es verdadero.
const toggleVisibility = (el, show) => el?.classList.toggle("dn", !show);

// --- Manejo de Entidades (Unificado) ---
function getSelectedEntityDbid(elementId) {
  const el = getEl(elementId);
  if (!el) return "";
  try {
    const sel = JSON.parse(el.getAttribute("selected") || "[]");
    return sel.length ? String(sel[0]) : "";
  } catch (e) {
    return "";
  }
}

function clearAutocomplete(elementId) {
  const el = getEl(elementId);
  if (!el) return;
  
  el.setAttribute("selected", "[]");
  const chipCont = el.querySelector(".chip-cont");
  if (chipCont) chipCont.innerHTML = "";
  const input = el.querySelector(".elem");
  if (input) input.value = "";
}

// Mantenemos estas funciones como wrappers para inyectarlas en los reportes
const getSelectedCustomerDbid = () => getSelectedEntityDbid("reportHub_form_customer_id");
const getSelectedProviderDbid = () => getSelectedEntityDbid("reportHub_form_provider_id");

function getAutocompleteEntityId(def) {
  return def.autocompleteEntity === "provider" 
    ? getSelectedProviderDbid() 
    : getSelectedCustomerDbid();
}

// --- Manejo de UI ---
function applyFilterVisibility(def) {
  toggleVisibility(getEl("reportHub-filter-dates"), def.filterDateRange);
  toggleVisibility(getEl("reportHub-filter-year-wrap"), def.filterYear);
  
  const entityWrap = getEl("reportHub-filter-entity-wrap");
  toggleVisibility(entityWrap, def.needsAutocomplete);
  
  if (def.needsAutocomplete) {
    const isProvider = def.autocompleteEntity === "provider";
    toggleVisibility(getEl("reportHub-filter-provider-wrap"), isProvider);
    toggleVisibility(getEl("reportHub-filter-customer-wrap"), !isProvider);
  }
}

function clearFilterInputs() {
  const from = getEl("reportHub_filter_date_from");
  const to = getEl("reportHub_filter_date_to");
  const year = getEl("reportHub_filter_year");
  
  if (from) from.value = "";
  if (to) to.value = "";
  if (year) year.checked = false;
  
  clearAutocomplete("reportHub_form_customer_id");
  clearAutocomplete("reportHub_form_provider_id");
}

// --- Ejecución ---
export function executeReport(def, filters) {
  const handlers = {
    customer: () => customerReports.getData(def, filters, { getSelectedCustomerDbid }),
    provider: () => providerReports.getData(def, filters, { getSelectedProviderDbid }),
  };

  const handler = handlers[def.handler];
  handler ? handler() : snack.start({ act: "show", id: "downloadError" });
}

export function onSelectReport(detail) {
  const def = getReportDefinition(detail.reportId);
  if (!def) return;
  
  activeDefinition = def;
  clearFilterInputs();
  applyFilterVisibility(def);

  const filterCard = getEl("reportHub-filter-card");

  if (def.autoPrintWithoutUI && !def.needsAutocomplete) {
    toggleVisibility(filterCard, false);
    executeReport(def, {});
    return;
  }

  toggleVisibility(filterCard, true);
}

export function onRunFilteredReport() {
  if (!activeDefinition) return;
  
  const filters = {
    startDate: getElValue("reportHub_filter_date_from"),
    endDate: getElValue("reportHub_filter_date_to"),
    useYear: !!getEl("reportHub_filter_year")?.checked,
  };
  
  if (activeDefinition.needsAutocomplete) {
    filters.entityId = getAutocompleteEntityId(activeDefinition);
  }
  
  executeReport(activeDefinition, filters);
}